module.exports = __webpack_public_path__ + "static/img/2.a5c003a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/oem/R507/2.jpg
// module id = g8ab
// module chunks = 1